import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BrandMark } from '@/components/brand/BrandMark';

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2">
            <BrandMark variant="icon" size="sm" />
            <span className="font-display text-base font-semibold">Praxara</span>
          </Link>
          <nav className="flex items-center gap-4 text-xs text-muted-foreground">
            <Link to="/legal/terms" className="hover:text-foreground">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-foreground">Privacy</Link>
            <Link to="/legal/dpa" className="hover:text-foreground">DPA</Link>
            <Link to="/legal/cookies" className="hover:text-foreground">Cookies</Link>
            <Link to="/legal/subprocessors" className="hover:text-foreground">Sub-processors</Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-3 w-3" /> Back to Praxara
        </Link>
        <div className="mt-4">
          <h1 className="font-display text-3xl">{title}</h1>
          <p className="mt-1 text-xs text-muted-foreground">Last updated: {lastUpdated}</p>
        </div>

        <div className="legal-prose mt-8">{children}</div>

        <div className="mt-16 border-t pt-6 text-xs text-muted-foreground">
          This document is a template. It must be reviewed and adapted by qualified legal
          counsel before use with paying customers.
        </div>
      </main>
    </div>
  );
}
